import { BaseComponent } from '../base-component.js';
import { api } from '../../client/api.js';
import componentStyles from './verify-email-page.css?inline';

type State =
  | { status: 'loading' }
  | { status: 'success'; message: string }
  | { status: 'error'; message: string };

export class VerifyEmailPage extends BaseComponent {
  private state: State = { status: 'loading' };

  protected styles(): string {
    return componentStyles;
  }

  protected template(): string {
    if (this.state.status === 'loading') {
      return `
        <ag-panel>
          <ag-panel-header><h1>Verifying Email</h1></ag-panel-header>
          <ag-panel-content>
            <p>Please wait while we verify your email address...</p>
          </ag-panel-content>
        </ag-panel>
      `;
    }

    if (this.state.status === 'success') {
      return `
        <ag-panel>
          <ag-panel-header><h1>Email Verified</h1></ag-panel-header>
          <ag-panel-content>
            <div class="ag-alert success">${this.state.message}</div>
            <a href="/login" class="action-link">Sign In</a>
          </ag-panel-content>
        </ag-panel>
      `;
    }

    return `
      <ag-panel>
        <ag-panel-header><h1>Verification Failed</h1></ag-panel-header>
        <ag-panel-content>
          <div class="ag-alert danger">${this.state.message}</div>
          <a href="/login" class="action-link">Back to Sign In</a>
        </ag-panel-content>
      </ag-panel>
    `;
  }

  connectedCallback(): void {
    super.connectedCallback();
    this.verify();
  }

  private async verify(): Promise<void> {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) {
      this.state = { status: 'error', message: 'No verification token provided. Please check your email link.' };
      this.render();
      return;
    }

    const result = await api.verifyEmail(token);
    if (result.data) {
      this.state = { status: 'success', message: result.data.message || 'Your email has been verified successfully.' };
    } else {
      this.state = { status: 'error', message: result.error || 'Verification failed. The link may have expired.' };
    }
    this.render();
  }
}

customElements.define('verify-email-page', VerifyEmailPage);
